import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { trafficApi } from '../api/trafficIntelligence'

export default function FanTrafficOrigin({ modelId, fanId }) {
  const [state, setState] = useState({ key: '', origins: [], error: '', loading: true })
  const key = `${modelId}:${fanId}`
  useEffect(() => {
    let alive = true
    setState({ key, origins: [], error: '', loading: true })
    trafficApi('fan-origin', { params: { model_id: modelId, fan_id: fanId } })
      .then((result) => { if (alive) setState({ key, origins: result.origins || [], error: '', loading: false }) })
      .catch(() => { if (alive) setState({ key, origins: [], error: 'Traffic attribution unavailable', loading: false }) })
    return () => { alive = false }
  }, [modelId, fanId, key])
  if (state.key !== key || state.loading) return <section className="v2-inspector-section"><span className="v2-inspector-label">Acquisition</span><p>Loading attribution…</p></section>
  return <section className="v2-inspector-section">
    <span className="v2-inspector-label">Acquisition / Traffic Intelligence</span>
    {state.error ? <p>{state.error}</p> : !state.origins.length ? <p>No confirmed traffic attribution</p> : state.origins.map((origin) => <div key={`${origin.agency_id}:${origin.id}`}>
      <strong>{origin.campaign}</strong>
      <p>{origin.provider} · {origin.source || 'Source unknown'} · {origin.agency}</p>
      <p>Joined {new Date(origin.acquired_at).toISOString().slice(0, 10)} UTC<br />
        Allocated cost: {origin.cost == null ? 'unknown' : `$${origin.cost.toFixed(2)}`}<br />
        Recorded revenue: ${origin.revenue.toFixed(2)} · {origin.purchases} purchases</p>
      {!origin.coverage_complete && <p>Partial data — not a profitability recommendation</p>}
      <Link to={`/v2/traffic-intelligence?agency_id=${origin.agency_id}&model_id=${modelId}&fan_id=${fanId}`}>View traffic cohort</Link>
    </div>)}
  </section>
}
